import { Center, Spinner } from '@chakra-ui/react';
import { CustomSpinnerProps } from '@/interfaces/Interfaces';

export default function CustomSpinner({ height, ...props }: CustomSpinnerProps) {
  return (
    <Center height={height ? height : undefined}>
      <Spinner size="xl" color="teal" mb={2} {...props} />
    </Center>
  );
}
